import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../../config/api";
import { number_format } from "../../../../../config/Helpers";

const postUrlLogin  = API_URL + "widgets";

class Adr extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            result_rows     : "",
            total_widgets   : { 
                adr_ly_by_widget : 0 , 
                adr_books_by_widget : 0, 
                adr_budget_by_widget : 0, 
                adr_bb_by_widget : 0 }
        }
    }
    activeWdg(type){
        this.props.activeWidget(type)
    }
    componentWillReceiveProps(props){ }
    
    getRow(wdg_aux, filt, index, title = true){
        return filt !== "totals" ? 
        <div key={"list-room-night-"+index} className={ index%2 ? "row-c" : "" }>
            <div>${ number_format(wdg_aux[filt].adr_ly, 2) }</div>
            <div>${ number_format(wdg_aux[filt].adr_books, 2) }</div>
            <div>${ number_format(wdg_aux[filt].adr_budget, 2) }</div>
            <div>{ this.props.filter_by_pace === 0 ? wdg_aux[filt].adr_book_vs_budget :  wdg_aux[filt].adr_pace}%</div>
        </div>
    :   <div className={"datagrid-month " + (title === true ? "totals" : (index%2 ? "row-c" : ""))}>
            <div>${ number_format(wdg_aux[filt].adr_ly_by_widget, 2)}</div>
            <div>${ number_format(wdg_aux[filt].adr_books_by_widget, 2)}</div>
            <div>${ number_format(wdg_aux[filt].adr_budget_by_widget, 2)}</div>
            <div>{ this.props.filter_by_pace === 0 ? wdg_aux[filt].adr_bb_by_widget : wdg_aux[filt].adr_by_widget_pace }%</div>
        </div>
    }
    componentWillReceiveProps(props){
        const
            has_statics_channels  = (Object.keys(this.props.statics_channels).length > 0),
            has_statics_segments  = (Object.keys(this.props.statics_segments).length > 0),
            has_statics_trimester = (Object.keys(this.props.statics_trimester).length > 0),
            has_statics_time      = (Object.keys(this.props.statics).length > 0),
            has_totals_channels   = (Object.keys(this.props.total_widgets_channels).length > 0)

        let wdg_aux = [], totals_general = "";

        /*if(has_totals_channels){
            this.state.total_widgets = this.props.total_widgets_channels;
        }else{
            this.state.total_widgets = this.props.total_widgets;
        }*/
        wdg_aux["channels"] = this.props.statics_channels; 
        wdg_aux["segments"] = this.props.statics_segments; 
        wdg_aux["trimester"] = this.props.statics_trimester; 
        wdg_aux["months"] = this.props.statics; 
        
        this.state.totals_general = (<div className={"datagrid-month totals"}>
                                <div>${ number_format(this.state.total_widgets.adr_ly_by_widget, 2) }</div>
                                <div>${ number_format(this.state.total_widgets.adr_books_by_widget, 2) }</div>
                                <div>${ number_format(this.state.total_widgets.adr_budget_by_widget, 2) }</div>
                                <div>{ this.props.filter_by_pace === 0 ? this.state.total_widgets.adr_bb_by_widget : this.state.total_widgets.adr_by_widget_pace}%</div>
                            </div>);

        if(Object.keys(wdg_aux).length > 0){
            let key_times = this.props.layout.state.segmentActive;
            this.state.result_rows = Object.keys(this.props.statics).map((filt, index) => {
                if(has_statics_channels){
                    if(wdg_aux["channels"][filt] !== undefined){
                        const wdg = wdg_aux["channels"][filt];
                        return Object.keys(wdg).map((filt_aux, index_aux) => {
                            if(filt_aux !== "totals"){
                                //if(wdg[filt_aux].num_reservations !== 0){
                                    let channel_list = wdg[filt_aux];
                                    if(key_times[filt_aux] !== undefined){
                                        return Object.keys(channel_list).map((filt_channel, index_channel) => {
                                            return this.getRow(channel_list, filt_channel, index_aux)
                                        })
                                    }else{
                                        return this.getRow(wdg[filt_aux], "totals", index_aux, false)
                                    }
                                //}
                            }else{
                                return this.getRow(wdg, filt_aux, index_aux)
                            }
                        })
                    }
                }   
                if(has_statics_segments){
                    if(wdg_aux["segments"][filt] !== undefined){
                        const wdg = wdg_aux["segments"][filt];
                        return Object.keys(wdg).map((filt_aux, index_aux) => {
                            //if(wdg[filt_aux].num_reservations !== 0){
                                return this.getRow(wdg, filt_aux, index_aux)
                            //}
                        })
                    }
                }
                if(has_statics_time){
                    //if(wdg_aux["months"][filt].num_reservations !== 0){
                        return this.getRow(wdg_aux["months"], filt, index)
                    //}
                }
            })
        }
        this.setState({ total_widgets : this.props.total_widgets });
    }
    render(){
        return (
            <div className={"datagrid-widget adr  "+ this.props.hidden_wdg_adr}>
                <div className="container-fluid">
                    <div className="row header-widget">
                        <div className="col-md-12 options-widget">
                            <span className="title">ADR</span>
                            <span className="opt remove-widget" onClick={this.activeWdg.bind(this, "adr")}>
                                <img src={DeleteFilter} />
                            </span>
                        </div>
                    </div>
                    <div className="current-values">
                        <div className="row">
                            <div className="col-md-12 head-current">
                                <span>{this.props.app.state.past_year}</span>
                                <span>{this.props.app.state.current_year}</span>
                                <span>Budget</span>
                                <span>Book vs.<br /> {this.props.filter_by_pace === 0 ? "Budget" : this.props.app.state.past_year}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 datagrid-list">
                                {this.state.result_rows}
                                { this.state.totals_general }
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
        )
    }
}

export default Adr



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/views/Review/Adr.js